/**
 * 00:00 Europe/Zurich on the Top Listing BUY price change day. A Top Listing BUY that starts at or after
 * this moment costs the current `toplisting-prices` BUY price (CHF 17.20, ASR-1936); an earlier start
 * keeps its old price. The offset must be Zurich's offset on that day (+02:00 until Oct 25, 2026, then +01:00).
 * transaction-service-v2 bills with the same day (`UBM_TOP_LISTING_BUY_PRICE_CHANGE_DATE`), so change both together.
 */
const TOP_LISTING_BUY_PRICE_CHANGE_START = '2026-10-21T00:00:00+02:00';

/** The price change day as `YYYY-MM-DD`. */
export const TOP_LISTING_BUY_PRICE_CHANGE_DAY = TOP_LISTING_BUY_PRICE_CHANGE_START.slice(0, 10);

export const TOP_LISTING_BUY_PRICE_CHANGE_TIMESTAMP = Date.parse(
  TOP_LISTING_BUY_PRICE_CHANGE_START,
);

/**
 * @param date - An ISO timestamp, epoch milliseconds, or a `YYYY-MM-DD` day (parsed as UTC midnight,
 *   which is after the cutoff for the price change day and before it for the day before)
 */
export function isOnOrAfterTopListingBuyPriceChange(date: string | number): boolean {
  const timestamp = new Date(date).getTime();
  return Number.isFinite(timestamp) && timestamp >= TOP_LISTING_BUY_PRICE_CHANGE_TIMESTAMP;
}
